import { createDynamicEndpointRegex } from "@/helpers";

export const QUERIES_ADMIN = {
  BFF_ADDRESS: {
    module: "bff-address",
  },
  ADDRESS: {
    module: "address",
  },
  AUTH: {
    module: "auth",
  },
  PROFILE: {
    module: "profile",
  },
  FINANCE_PROFILE: {
    module: "finance-profile",
  },
  SUPPLIER_ORDER: {
    module: "supplier-order",
  },
  BFF_SUPPLIER_PAYMENT: {
    module: "bff-supplier-payment",
  },
  BFF_SUPPLIER_ORDER_MANAGMENT: {
    module: "bff-supplier-order-managment",
  },
  BFF_SUPPLIER_ORDER_MANAGMENT_PURCHASE_ORDER_ITEMS: {
    module: "bff-supplier-order-managment-purchase-order-items",
  },
  BFF_SUPPLIER_ORDER_MANAGMENT_PURCHASE_ORDER_COMMENTS: {
    module: "bff-supplier-order-managment-purchase-order-comments",
  },
  BFF_SUPPLIER_ORDER_MANAGMENT_PURCHASE_ORDER_HISTORY: {
    module: "bff-supplier-order-managment-purchase-order-history",
  },
  SUPPLIER_TRANSACTION: {
    module: "supplier-transaction",
  },
  BFF_SUPPLY_TRANSACTION: {
    module: "bff-supplier-transaction",
  },
  GENERATE_PURCHASE_ORDER: {
    module: "generate-purchase-order",
  },
  GENERATE_PURCHASE_ORDER_PREVIEW: {
    module: "generate-purchase-order-preview",
  },
  GENERATE_PURCHASE_ORDER_PDF_PREVIEW: {
    module: "generate-purchase-order-pdf-preview",
  },
  GENERATE_SUPPLIER_ORDER_PREVIEW: {
    module: "generate-supplier-order-preview",
  },
  SUPPLIER_ORDER_PREVIEW: {
    module: "supplier-order-preview",
  },
  SUPPLIER_ORDER_PDF_PREVIEW: {
    module: "supplier-order-pdf-preview",
  },
  SUPPLIER_ITEMS_PREVIEW: {
    module: "supplier-items-preview",
  },
  BFF_SUPPLY_ORDER_PAYMENT_REQUIRED: {
    module: "supply-payment-required",
  },
  QUOTATION: {
    module: "quotation",
  },
  QUOTATION_HISTORY_URL: {
    module: "quotation-history",
  },
  QUOTATION_BULK: {
    module: "quotation-bulk",
  },
  QUOTATION_CLASSIFICATION: {
    module: "quotation-classification",
  },
  QUOTATION_SLAS: {
    module: "quotation-slas",
  },
  QUOTATION_REQUEST: {
    module: "quotation-request",
  },
  QUOTATION_REQUEST_BULK: {
    module: "quotation-request-bulk",
  },
  QUOTATION_REQUEST_CLASSIFICATION: {
    module: "quotation-request-classification",
  },
  QUOTATION_REQUEST_SLAS: {
    module: "quotation-request-slas",
  },
  QUOTATION_REQUEST_SPLIT: {
    module: "quotation-request-split",
  },
  WHO_AM_I: {
    module: "who-am-i",
  },
  CATALOG_CATEGORY: {
    module: "catalog-category",
  },
  CATALOG_PRODUCT: {
    module: "catalog-product",
  },
  FILE: {
    module: "file",
  },
  ORDER: {
    module: "order",
  },
  ORDER_ITEM: {
    module: "order-item",
  },
  USER: {
    module: "user",
  },
  ACCOUNT_LEVEL_QUESTION: {
    module: "account-level-question",
  },
  SEARCH_ENGINE: {
    module: "search-engine",
  },
  INVENTORY: {
    module: "inventory",
  },
  INVENTORY_TRANSACTION: {
    module: "inventory-transaction",
  },
  SUPPLIER: {
    module: "supplier",
  },
  SUPPLIER_WAREHOUSE: {
    module: "supplier-warehouse",
  },
  SUPPLIER_PRODUCTS: {
    module: "supplier-products",
  },
  BFF_FORECASTS_AND_INVENTORIES: {
    module: "bff-forecasts-and-inventories",
  },
  BFF_FORECAST: {
    module: "bff-forecast",
  },
  BFF_SUPPLIER_PRODUCTS: {
    module: "bff-supplier-products",
  },
  BFF_SUPPLIER_PRODUCTS_METRICS: {
    module: "bff-supplier-products-metrics",
  },
  BFF_SALE_ORDER_SUPPLY_ORDERS_URL: {
    module: "bff-sale-order-supply-orders",
  },
  BFF_SALE_ORDER_SUPPLY_ORDERS_DELETE_URL: {
    module: "bff-sale-order-supply-orders-delete",
  },
  BFF_SUPPLIER_FORECAST_WITH_SUPPLIER_PRODUCT: {
    module: "bff-supplier-forecast-with-supplier-product",
  },
  TRANSPORT_COMPANY: {
    module: "transport-company",
  },
  ROUTE: {
    module: "routes",
  },
  ROUTE_ORIGIN: {
    module: "routes-origins",
  },
  VEHICLES: {
    module: "vehicles",
  },
  TRANSPORT_COMPANY_ROUTE: {
    module: "transport-company-routes",
  },
  ORDER_TRACKER: {
    module: "order-tracker",
  },
  KAI_PROCESSOR: {
    module: "kai-processor",
  },
  DOLLAR_QUOTATION: {
    module: "dollar-quotation",
  },
  UPDATE_SUPPLY_ORDER_ON_SALE_ORDER_CANCEL: {
    module: "update-supply-order-on-sale-order-cancel",
  },
  ORDER_CENTER: {
    module: "order-center",
  },
  ORDER_CENTER_BULK: {
    module: "order-center-bulk",
  },
  ORDER_CENTER_COMMENTS: {
    module: "order-center-comments",
  },
  ORDER_CENTER_HISTORIES: {
    module: "order-center-histories",
  },
  ORDER_CENTER_LOGISTIC_GENERATE_REMISSION: {
    module: "order-center-logistic-generate-remission",
  },
  CREDIT_ORDER: {
    module: "credit-order",
  },
  TRANSACTION: {
    module: "transaction",
  },
  PROFILE_USER: {
    module: "profile-user",
  },
  SALE_BOARD: {
    module: "sale-board",
  },
  CALCULATE_MARGIN: {
    module: "calculate-margin",
  },
  CALCULATE_UNIT_PRICE_URL: {
    module: "calculate-unit-price",
  },
  CALCULATE_LOGISTIC_COSTS_URL: {
    module: "calculate-logistic-costs",
  },
  BFF_CALCULATE_LOGISTIC_CUSTOMS_COSTS_URL: {
    module: "calculate-logistic-customs-costs",
  },
  AI_AGENT: {
    module: "ai-agent",
  },
  AI_CONVERSATION: {
    module: "ai-conversation",
  },
  AI_CONVERSATION_METRICS: {
    module: "ai-conversation-metrics",
  },
  AI_DASHBOARD_MONTHLY_METRICS: {
    module: "ai-dashboard-monthly-metrics",
  },
  AI_MESSAGE: {
    module: "ai-message",
  },
  AI_EVALUATION: {
    module: "ai-evaluation",
  },
  AI_REACTIVATION_META_TEMPLATE: {
    module: "ai-reactivation-meta-template",
  },
  AI_REGENERATE: {
    module: "ai-regenerate",
  },
  AI_TAG: {
    module: "ai-tag",
  },
  LEAD: {
    module: "lead",
  },
  BFF_SHIPMENT_INVOICE: {
    module: "bff-shipment-invoice",
  },
  AI_HOST_CONVERSATION: {
    module: "ai-host-conversation",
  },
};

export const SENTRY_EXCLUDED_ENDPOINTS: {
  pathname: string | RegExp;
  method: "put" | "patch" | "post" | "get" | "delete";
}[] = [
  {
    pathname: createDynamicEndpointRegex("/base/calculate-margin/"),
    method: "post",
  },
  {
    pathname: createDynamicEndpointRegex("/base/calculate-unit-price/"),
    method: "post",
  },
  {
    pathname: createDynamicEndpointRegex("/base/calculate-logistic-costs/"),
    method: "post",
  },
];
